import QRCodeInstruction from '#client/components/QRCodeInstruction';
import { UTM_TERM } from '#client/constants/campaign';
import { MODAL_NAMES } from '#client/constants/modals';
import { BASE_URL } from '#client/constants/url';
import useBankingPath from '#client/hooks/useBankingPath';
import useFormStep from '#client/hooks/useFormStep';

const ScanQRCodeBanner = () => {
  const bankingPath = useBankingPath();
  const { resubmitData } = useFormStep();
  const { checkId = '' } = resubmitData || {};

  const url = `${BASE_URL}${bankingPath}/dashboard?${UTM_TERM}=qrcode&modal=${MODAL_NAMES.RETRY_CHECK_DEPOSITS}&checkId=${checkId}`;

  return <QRCodeInstruction url={url} />;
};

export default ScanQRCodeBanner;
